import { Select } from '@cloudscape-design/components';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';

type ItemBookingType = {
    idBookingType: number;
    bookingType: string;
    showOnBooking: number;
    showOnFlightLog: number;
    value: string;
    label: string;
};
interface SelectBookingTypeProps {
    visible?: boolean;
    idBookingTypes?: number[];
    showOnBooking?: number;
    showOnFlightLog?: number;
    onSelect?: (selectedBookingType: any) => void;
    value?: number;
}
const SelectBookingType: React.FC<SelectBookingTypeProps> = ({
    visible,
    value,
    idBookingTypes = [],
    showOnBooking,
    showOnFlightLog,
    onSelect
}) => {
    const { data } = useGlobalState();

    //const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [bookingTypes, setBookingTypes] = useState<ItemBookingType[]>([]);
    const [bookingType, setBookingType] = useState<ItemBookingType>();


    const mappedBookingTypes: ItemBookingType[] = data.bookingTypes
        .filter((plan: ItemBookingType) =>
            (showOnBooking === undefined || plan.showOnBooking === showOnBooking) &&
            (showOnFlightLog === undefined || plan.showOnFlightLog === showOnFlightLog) &&
            (idBookingTypes.length === 0 || idBookingTypes.includes(plan.idBookingType))
        )
        .map((plan: ItemBookingType) => ({
            idBookingType: plan.idBookingType,
            bookingType: plan.bookingType,
            value: plan.idBookingType.toString(),
            label: plan.bookingType
        }));

    useEffect(() => {
        setBookingTypes(mappedBookingTypes);
        if (value)
            setBookingType(mappedBookingTypes.find(ut => ut.idBookingType === value));
    }, []);

    useEffect(() => {
        setBookingType(mappedBookingTypes.find((ut: { idBookingType: number; }) => ut.idBookingType === value));

    }, [value]);


    return (

        <div style={{ width: '200px' }}>
            <Select
                selectedOption={bookingType ?? null}
                onChange={({ detail }) => {
                    const selected = {
                        idBookingType: Number(detail.selectedOption.value),
                        bookingType: detail.selectedOption.label ?? "",
                        value: detail.selectedOption.value ?? "",
                        label: detail.selectedOption.label ?? ""
                    };
                    setBookingType(selected as ItemBookingType);

                    // Call only if onSelect is defined
                    if (onSelect) {
                        onSelect(selected);
                        value = selected.idBookingType;
                    }
                }
                }
                options={mappedBookingTypes}
            />
        </div>
    );
};

export default SelectBookingType;